import { processChannelSelectionsForSubmit } from './selectionUtils'

const cleanBeforeSending = (oldData) => {
    if (oldData.channel === 'wechat_group') {
        oldData.miniprogram = null
    }
    if (oldData.channel === 'miniprogram') {
        oldData.wechatGroup = null
    }

    let newClipboard = []
    if (!oldData.clipboard) {
        oldData.clipboard = []
    }
    const savedClipboard = [...oldData.clipboard]

    for (const clip of savedClipboard) {
        if (clip?.shortcut || clip?.text) newClipboard.push(clip)
    }
    oldData.clipboard = newClipboard

    oldData.fees = oldData.fees?.map((fee) => ({
        ...fee,
        area: fee.area ? fee.area[fee.area.length - 1] : undefined,
    }))

    //format pictures
    // if (oldData.banners?.en) {
    //     let mainEn = oldData.banners.en.fileList
    //         ? oldData.banners.en?.fileList
    //         : oldData.banners.en

    //     oldData.banners.en = mainEn.map((file) =>
    //         file.response ? file.response : file
    //     )
    // } else {
    //     if (!oldData.banners) {
    //         oldData.banners = {}
    //     }
    //     oldData.banners.en = []
    // }

    // if (oldData.banners?.zh) {
    //     let mainZh = oldData.banners.zh.fileList
    //         ? oldData.banners.zh?.fileList
    //         : oldData.banners.zh

    //     oldData.banners.zh = mainZh.map((file) =>
    //         file.response ? file.response : file
    //     )
    // } else {
    //     oldData.banners.zh = []
    // }

    // if (oldData.medias?.en) {
    //     let mainEn = oldData.medias.en.fileList
    //         ? oldData.medias.en?.fileList
    //         : oldData.medias.en

    //     oldData.medias.en = mainEn.map((file) =>
    //         file.response ? file.response : file
    //     )
    // } else {
    //     if (!oldData.medias) {
    //         oldData.medias = {}
    //     }
    //     oldData.medias.en = []
    // }
    // if (oldData.medias?.zh) {
    //     let mainZh = oldData.medias.zh.fileList
    //         ? oldData.medias.zh?.fileList
    //         : oldData.medias.zh

    //     oldData.medias.zh = mainZh.map((file) =>
    //         file.response ? file.response : file
    //     )
    // } else {
    //     oldData.medias.zh = []
    // }

    if (oldData.wechatGroup) {
        oldData.wechatGroup = processChannelSelectionsForSubmit(
            oldData.wechatGroup
        )

        if (!oldData.wechatGroup.lotteryEnable) {
            oldData.wechatGroup.lotteryEnable = false
            oldData.wechatGroup.lottery = null
        } else {
            // if (oldData.wechatGroup.lottery.draws) {
            //     const newMPDraws = []
            //     for (const draw of oldData.wechatGroup.lottery.draws) {
            //         const newMPGifts = []
            //         if (draw?.gifts?.length > 0) {
            //             for (const gift of draw.gifts) {
            //                 let customImage = {}
            //                 newMPGifts.push({
            //                     ...gift,
            //                     customImage,
            //                 })
            //             }
            //         }
            //         newMPDraws.push({ ...draw, gifts: newMPGifts })
            //     }
            //     oldData.wechatGroup.lottery.draws = newMPDraws
            // }
        }

        if (oldData?.wechatGroup?.zikoSpecials) {
            // const newWXSpecials = []
            // for (const special of oldData.wechatGroup.zikoSpecials) {
            //     let customImage = {}
            //     console.log(special.gift)
            //     newWXSpecials.push({
            //         ...special,
            //         gift: { ...special.gift, customImage },
            //     })
            // }
            // oldData.wechatGroup.zikoSpecials = newWXSpecials
        }
    }
    if (oldData.miniprogram) {
        oldData.miniprogram = processChannelSelectionsForSubmit(
            oldData.miniprogram
        )

        if (!oldData.miniprogram.lotteryEnable) {
            oldData.miniprogram.lotteryEnable = false
            oldData.miniprogram.lottery = null
        } else {
            // if (oldData.miniprogram.lottery.draws) {
            //     const newMPDraws = []
            //     for (const draw of oldData.miniprogram.lottery.draws) {
            //         const newMPGifts = []
            //         if (draw?.gifts?.length > 0) {
            //             for (const gift of draw?.gifts) {
            //                 let customImage = {}
            //                 if (gift.type === 'custom') {
            //                     customImage = gift?.customImage?.fileList
            //                         ? gift.customImage?.fileList
            //                         : gift.customImage
            //                     if (!Array.isArray(customImage)) {
            //                         customImage = [customImage]
            //                     }
            //                     const newImg = customImage.map((file) =>
            //                         file.response ? file.response : file
            //                     )
            //                     customImage = newImg.length ? newImg[0] : {}
            //                 }
            //                 newMPGifts.push({
            //                     ...gift,
            //                     customImage,
            //                 })
            //             }
            //         }
            //         newMPDraws.push({ ...draw, gifts: newMPGifts })
            //     }
            //     oldData.miniprogram.lottery.draws = newMPDraws
            // }
        }

        if (oldData.miniprogram?.zikoSpecials) {
            // const newMPSpecials = []
            // for (const special of oldData.miniprogram?.zikoSpecials) {
            //     let customImage = {}
            //     if (special.gift && special.gift.type === 'custom') {
            //         customImage = special.gift?.customImage?.fileList
            //             ? special.gift.customImage?.fileList
            //             : special.gift.customImage
            //         if (!Array.isArray(customImage)) {
            //             customImage = [customImage]
            //         }
            //         const newImg = customImage.map((file) =>
            //             file.response ? file.response : file
            //         )
            //         customImage = newImg.length ? newImg[0] : {}
            //     }
            //     newMPSpecials.push({
            //         ...special,
            //         gift: { ...special.gift, customImage },
            //     })
            // }
            // oldData.miniprogram.zikoSpecials = newMPSpecials
        }
    }

    return oldData
}

export default cleanBeforeSending
